import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Scrollable content pane that occupies the right side (desktop) or
 * bottom section (mobile) of a `LocationCard`. Purely structural.
 */
const LocationCardContent = styled(Box)({
  flex: 1,
  padding: "14px 20px",
  display: "flex",
  flexDirection: "column",
  gap: 6,
  minWidth: 0, // prevents flex overflow of long text
});

export default LocationCardContent;

